import { useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import MobileBottomNav from "@/components/MobileBottomNav";
import { AuthModal } from "@/components/auth/AuthModal";
import { Toaster } from "@/components/ui/sonner";
import { useAuth } from "@/contexts/AuthContext";

function getMobileBottomSpacing(pathname) {
  const hideBottomNav =
    pathname.startsWith("/admin") ||
    pathname.startsWith("/promotor") ||
    pathname.startsWith("/estabelecimento") ||
    pathname.startsWith("/apresentador") ||
    pathname.startsWith("/reset-password") ||
    pathname.startsWith("/politica-de-privacidade") ||
    pathname.startsWith("/quiz-especial/") ||
    pathname.startsWith("/avaliar");

  return hideBottomNav ? "" : "pb-24 lg:pb-0";
}

function isPublicAppRoute(pathname) {
  return (
    pathname.startsWith("/reset-password") ||
    pathname.startsWith("/politica-de-privacidade") ||
    pathname.startsWith("/avaliar")
  );
}

export default function AppShell({ children }) {
  const location = useLocation();
  const { user, loading } = useAuth();
  const isFeedbackRoute = location.pathname.startsWith("/avaliar");

  const loginRequired = !loading && !user && !isPublicAppRoute(location.pathname);

  if (loginRequired) {
    return (
      <>
        <div className="min-h-screen bg-[#050505]" />
        <AuthModal open={true} onClose={() => {}} />
        <Toaster position="top-right" />
      </>
    );
  }

  return (
    <>
      {!isFeedbackRoute && <Navbar />}
      <main className={getMobileBottomSpacing(location.pathname)}>
        {children}
      </main>
      {!isFeedbackRoute && <MobileBottomNav />}
      <Toaster position="top-right" />
    </>
  );
}
